"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_options_html_1 = __importDefault(require("./global-options.html"));
require("./global-options.less");
(function (module) {
    'use strict';
    module.factory('prGlobalOptionsModal', [
        '$rootScope',
        'qstrap.modal',
        'rsWidgets',
        function ($rootScope, modal, rsWidgets) {
            function show(options) {
                var scope = $rootScope.$new();
                scope.selectedIndex = (options && options.selectedIndex) || 0;
                rsWidgets.ensureDependency('eng/component-base').then(function () {
                    modal({
                        show: true,
                        scope: scope,
                        templateUrl: global_options_html_1.default,
                        controller: 'prGlobalOptionsController'
                    });
                });
            }
            return {
                show: show
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
